import * as React from "react";

import "./create-voucher-modal.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {Load2}           from "@Common/react/load2";
import {UseState}        from "@Common/react/use-state";
import {ConfirmDialog}   from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {ModalService3}   from "@Common/ui-components/modal-service-3/modal-service-3";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";

import {VoucherForm} from "../details-modal/voucher-modal/edit-panel/voucher-form/voucher-form";

import {CreateDetailsTable} from "./create-details-table/create-details-table";

export const CreateVoucherModal = ({filter, onSaved, next: rootNext}) => cs(
    consumeContext("apis"),
    ["modal", (_, next) => ModalService3({
        title: "Create New Voucher",
        rootNext,
        width: 530,
        urlParam: "create",
        contentService: next,
        xdQaName: "Create New Voucher",
    })],
    ["confirmClose", ({}, next) => ConfirmDialog({
        next: (dialog) => next(() => dialog.show({
            actionName: "exit",
            message: "Your changes have not been saved.",
            buttons: {
                confirmLabel: "Yes",
            },
        })),
    })],
    ["submitting", ({}, next) => UseState({initValue: false, next})],
    ["createDetailsTable", ({}, next) => CreateDetailsTable({
        filter,
        next,
    })],
    ["billingAccounts", ({apis, createDetailsTable}, next) => Load2({
        _key: JSON.stringify(createDetailsTable.value?.idProgram),
        fetch: () => createDetailsTable?.value?.idProgram && apis.next.billing.getBillingAccounts({
            idProgram: createDetailsTable.value?.idProgram,
            idBranch: filter.value?.idBranch,
            idAgent: createDetailsTable.value?.idAgent,
            idRegion: createDetailsTable.value?.idRegion,
        }),
        next,
    })],
    ["form", ({billingAccounts}, next) => VoucherForm({
        voucher: null, 
        billingAccountsList: billingAccounts?.value,
        next
    })],
    ({modal: {close, next}, apis, confirmClose, form, submitting, createDetailsTable}) => next({
        onPassiveClose: async () => {
            return (createDetailsTable.hasChanges() || form.hasChanges()) ? (
                await confirmClose() && close()
            ) : (
                close()
            )
        },
        content: (
            <div className="create-voucher-modal-i41">
                <div className="main">
                    <div className="content">
                        {createDetailsTable.render()}

                        <div className="edit-panel">
                            {createDetailsTable.noProgramAvailable ? (
                                <div xd-qa-type="label" xd-qa-name="No Program Available">
                                    This user already has a voucher in every available program. 
                                    Please close this modal and search this user’s name to make changes to this user’s vouchers.
                                </div>
                            ) : (
                                form.render()
                            )}
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <button {...{
                        className: "cancel",
                        onClick: async () => {
                            return (createDetailsTable.hasChanges() || form.hasChanges()) ? (
                                await confirmClose() && close()
                            ) : (
                                close()
                            )
                        }
                    }}
                        xd-qa-type="button"
                        xd-qa-name="Cancel"
                    >
                        Cancel
                    </button>
                    <button {...{
                        className: "save",
                        disabled: !createDetailsTable.valid || form.invalid || submitting.value || !form.changed?.total,
                        onClick: async () => {
                            submitting.onChange(true)
                            await apis.next.vouchers.createVoucherCode({
                                idProgram: createDetailsTable.value.idProgram,
                                idAgent  : createDetailsTable.value.idAgent,
                                idBillingAccount: form.changed.billingAccount,
                                amount: form.changed.total.toFixed(2),
                                expirationDate: form.changed.date && parseDateFormat("yyyy-mm-dd").formatDate(form.changed.date),
                                description: "Created Voucher",
                                comments: form.changed.comments,
                            })
                            submitting.onChange(false)
                            onSaved?.();
                            close();
                        }
                    }}
                        xd-qa-type="button"
                        xd-qa-name="Save"
                    >
                        Save
                    </button>
                </div>
            </div>
        ),
    }),
);
